// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2fDG9","additionalInfo":"AgreementModal_additionalInfo__3NLOc"};